import React from 'react';
import { Link } from 'react-router-dom';
import { StaticPageLayout } from '../StaticPageLayout';
import styles from '../Education/ScienceOfTime.module.scss';
import { usePageSEO } from '../../../hooks/usePageSEO';
import { tokens } from '../../../styles/tokens';

const titleStyle = { color: tokens.inkBlack, textDecoration: 'none' } as const;
const bodyStyle = { color: tokens.charcoal, marginBottom: '1.5rem' } as const;
const ctaStyle = { color: tokens.skyBlue, fontWeight: 700, textDecoration: 'none' } as const;

export const BlogIndex: React.FC = () => {
  usePageSEO({
    title: "MyMinu Blog - Parenting Strategies",
    description: "Tips, research, and strategies for building happier family routines. Read our latest articles.",
    url: window.location.origin + "/blog"
  });

  return (
    <StaticPageLayout>
      <div className={styles.container}>
        
        <div className={styles.header}>
          <h1>MyMinu Blog</h1>
          <p className={styles.subtitle}>
            Tips, research, and strategies for building happier family routines.
          </p>
        </div>

        <div style={{ display: 'grid', gap: '2rem' }}>
          
          {/* Post 1 */}
          <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', border: '1px solid rgba(28, 28, 28, 0.1)', boxShadow: '0 4px 12px rgba(28, 28, 28, 0.05)' }}>
            <h2 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.8rem' }}>
              <Link to="/blog/abstract-time" style={titleStyle}>
                Why "5 Minutes" Doesn't Work
              </Link>
            </h2>
            <p style={bodyStyle}>
              Most kids ages 3–7 don’t truly understand minutes. Learn why "we're leaving soon" creates confusion, not urgency, and what to say instead.
            </p>
            <Link to="/blog/abstract-time" style={ctaStyle}>
              Read Article →
            </Link>
          </div>

          {/* Post 2 */}
          <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', border: '1px solid rgba(28, 28, 28, 0.1)', boxShadow: '0 4px 12px rgba(28, 28, 28, 0.05)' }}>
            <h2 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.8rem' }}>
              <Link to="/blog/routine-engine" style={titleStyle}>
                The Routine Engine
              </Link>
            </h2>
            <p style={bodyStyle}>
              Routines aren’t about control; they’re a behavioral scaffold. Discover how predictable sequences reduce decision fatigue and shorten transitions.
            </p>
            <Link to="/blog/routine-engine" style={ctaStyle}>
              Read Article →
            </Link>
          </div>

          {/* Post 3 */}
          <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', border: '1px solid rgba(28, 28, 28, 0.1)', boxShadow: '0 4px 12px rgba(28, 28, 28, 0.05)' }}>
            <h2 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.8rem' }}>
              <Link to="/blog/visual-tools" style={titleStyle}>
                The Tools That Actually Help
              </Link>
            </h2>
            <p style={bodyStyle}>
              Visual timers support self-regulation, but only when used correctly. Learn the parent protocol for using tools without creating anxiety.
            </p>
            <Link to="/blog/visual-tools" style={ctaStyle}>
              Read Article →
            </Link>
          </div>

      </div>
    </div>
    </StaticPageLayout>
  );
};
